<template>
    <div>
        <div class="cloudPay">
            <p>编程语言：</p>
            <div style="padding: 4px 0 10px;">
                <AuthChooseItem v-for="(item,index) in $store.state.lessonVarity" :key='index'
                :selected='item.id == $route.params.id' 
                :name='item.name' 
                style='padding: 0 40px;'
                @click="click(item)" />
            </div>
            
        </div>
    </div>
</template>

<script>
    export default {
        name: 'cloadpay',
        methods: {
            click (item) {
                this.$router.push({path: '/detail/'+item.id})
            }
        }
    }
</script>

<style scoped>
    .cloudPay {
        background: rgb(245, 246, 248);
        padding: 10px;
    }

    .cloudPay p {
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
    }
</style>